import { ProductFeatures } from '@trello/product-features';
import { hasFreeBoardLimitDefined } from './hasFreeBoardLimitDefined';

export const isFreeBoardLimitOverridden = <Team>(team: Team): boolean => {
  if (
    ProductFeatures.hasProduct(
      (team as { products?: number[] }).products?.[0],
    ) ||
    !hasFreeBoardLimitDefined(team)
  ) {
    return false;
  }

  const limit = team.limits.orgs.freeBoardsPerOrg;

  return limit.disableAt !== 10;
};
